/**
 * Edge Edit Modal Component
 * Modal for editing edge/connection properties
 */

import React, { useState } from 'react';
import { useWorkflowStore } from '@flow-studio/store'; // import { workflowStore';
import { useUIStore } from '@flow-studio/store'; // import { uiStore';
import { ModalPortal } from './ModalPortal';

interface EdgeEditModalProps {
  edgeId: string;
  onClose: () => void;
}

export const EdgeEditModal: React.FC<EdgeEditModalProps> = ({ edgeId, onClose }) => {
  const { edges, updateEdge } = useWorkflowStore();
  const { theme } = useUIStore();

  const edge = edges.find(e => e.id === edgeId);

  // Convert label to string if it exists, otherwise empty string
  const labelString = edge?.label ? (typeof edge.label === 'string' ? edge.label : '') : '';

  const [edgeType, setEdgeType] = useState(edge?.type || 'smoothstep');
  const [animated, setAnimated] = useState(edge?.animated || false);
  const [label, setLabel] = useState(labelString);

  if (!edge) {
    return null;
  }

  const handleSave = () => {
    updateEdge(edgeId, {
      type: edgeType,
      animated,
      label: label || undefined,
    });
    onClose();
  };

  const themeClass = theme === 'light' ? 'light' : '';

  return (
    <ModalPortal>
      <div className="modal-overlay" onClick={onClose}>
        <div className={`modal ${themeClass}`} onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <div className="modal-header-content">
              <div className="modal-title"> Edit Connection</div>
              <div className="modal-subtitle">
                {edge.source} → {edge.target}
              </div>
            </div>
          </div>

          <div className="modal-body">
            <div className="modal-field">
              <label className={`modal-label ${themeClass}`}>Connection Type</label>
              <select
                className={`modal-select ${themeClass}`}
                value={edgeType}
                onChange={(e) => setEdgeType(e.target.value as "default" | "straight" | "step" | "smoothstep" | "simplebezier")}
              >
                <option value="default">Default</option>
                <option value="smoothstep">Smooth Step</option>
                <option value="step">Step</option>
                <option value="straight">Straight</option>
              </select>
            </div>

          <div className="modal-field">
            <label className={`modal-label ${themeClass}`}>Label (optional)</label>
            <input
              type="text"
              className={`modal-input ${themeClass}`}
              value={label}
              onChange={(e) => setLabel(e.target.value)}
              placeholder="Enter connection label"
            />
          </div>

          <div className="modal-field">
            <div className="modal-checkbox-container">
              <input
                type="checkbox"
                className="modal-checkbox"
                checked={animated}
                onChange={(e) => setAnimated(e.target.checked)}
                id="animated-checkbox"
              />
              <label
                htmlFor="animated-checkbox"
                className={`modal-checkbox-label ${themeClass}`}
              >
                Animated
              </label>
            </div>
          </div>
          </div>

          <div className={`modal-footer ${themeClass}`}>
            <button
              className={`modal-button secondary ${themeClass}`}
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="modal-button primary"
              onClick={handleSave}
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};
